"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M13.622 9.673c0 1.03-.866 1.874-1.926 1.874s-1.927-.843-1.927-1.874c0-1.03.867-1.873 1.927-1.873 1.059 0 1.926.843 1.926 1.873zM11.696 12.92c-1.51 0-4.496.719-4.496 2.186v1.686h9.084v-1.686c0-1.467-3.078-2.185-4.588-2.185z" }), "User");
//# sourceMappingURL=User.js.map